module.exports = __webpack_public_path__ + "img/preview-lg.c389eb82.png";